import {
  GET_DRIVER_LIST_ERROR,
  GET_DRIVER_LIST_SUCCESS,
  SET_DRIVER_LIST_LOADING,
  GET_DRIVER_DETAILS_SUCCESS,
  GET_DRIVERS_BY_CARRIER_ID_SUCCESS,
  SET_DRIVER_DETAILS_LOADING,
  SET_DRIVERS_BY_CARRIER_ID_LOADING,
  CREATE_DRIVER_SUCCESS,
  UPDATE_DRIVER_SUCCESS,
  REMOVE_DRIVER_SUCCESS,
} from '../constants/ActionTypes';

const INIT_STATE = {
  drivers: {
    list: null,
    pageCount: 0,
  },
  driversStoredByCarrierIds: {},
  details: null,
  loadingList: false,
  loadingDetails: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_DRIVER_LIST_ERROR:
      return {
        ...state,
        drivers: {
          ...state.drivers,
          list: null,
          pageCount: 0,
        },
      };
    case GET_DRIVER_LIST_SUCCESS:
      return {
        ...state,
        drivers: {
          list: action.payload.entities,
          pageCount: action.payload.pageCount,
        },
      };
    case SET_DRIVER_LIST_LOADING:
      return {
        ...state,
        loadingList: action.payload.isLoading,
      };
    case GET_DRIVER_DETAILS_SUCCESS:
      return {
        ...state,
        details: action.payload.bus,
      };
    case GET_DRIVERS_BY_CARRIER_ID_SUCCESS:
      return {
        ...state,
        driversStoredByCarrierIds: {
          ...state.driversStoredByCarrierIds,
          [action.payload.carrierId]: {
            ...state.driversStoredByCarrierIds[action.payload.carrierId],
            drivers: action.payload.drivers || [],
          },
        },
      };
    case SET_DRIVER_DETAILS_LOADING:
      return {
        ...state,
        loadingDetails: action.payload.isLoading,
      };
    case SET_DRIVERS_BY_CARRIER_ID_LOADING:
      return {
        ...state,
        driversStoredByCarrierIds: {
          ...state.driversStoredByCarrierIds,
          [action.payload.carrierId]: {
            ...state.driversStoredByCarrierIds[action.payload.carrierId],
            loading: action.payload.loading || false,
          },
        },
      };
    case CREATE_DRIVER_SUCCESS:
      return {
        ...state,
        drivers: {
          ...state.drivers,
          list: [...state.drivers.list, action.payload.driver],
        },
      };
    case UPDATE_DRIVER_SUCCESS: {
      const { driver } = action.payload;
      return {
        ...state,
        drivers: {
          ...state.drivers,
          list: state.drivers.list.map(
            item =>
              item.id === driver.id
                ? {
                    busCompany: driver.busCompany,
                    id: driver.id,
                    title: driver.title,
                    forename: driver.forename,
                    surname: driver.surname,
                    mobilePhone: driver.mobilePhone,
                    email: driver.email,
                    supervisorId: driver.supervisorId,
                  }
                : item,
          ),
        },
      };
    }
    case REMOVE_DRIVER_SUCCESS: {
      const { driverId } = action.payload;

      return {
        ...state,
        drivers: {
          ...state.drivers,
          list: state.drivers.list.filter(item => item.id !== driverId),
        },
      };
    }
    default:
      return state;
  }
};
